<template>
    <div class="lnk-panelfolder">
        <div class="panel-title" :class="hiddenIcon?'cancel-margin':''">
			<template v-if="title">
				<i class="pre-icon"></i>
				<span v-if="title">{{title}}</span>
			</template>
			<link-icon v-if="folder"
					   @click="show=!show"
					   class="folder-icon"
					   :icon="show?'link-icon-caret-up':'link-icon-caret-down'"></link-icon>
        </div>
        <transition name="switch">
            <div v-show="isShow" class="panel-content">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
/**
 @name: lnk-panelfolder 页面折叠器
 @createdby:HuangJian
 */
export default {
    name: 'lnk-panelfolder',
    props: {
        title: String,
		folder: Boolean,
        showDefault: {
            type: Boolean,
            default: true
        },
        hiddenIcon: {
            type: Boolean,
            default: false
        }
    },
	computed: {
    	isShow(){
    		return !this.folder || this.show;
		}
	},
    data(){
        return{show: this.showDefault};
    }
};
</script>

<style lang="scss">

	@include themeify{
		.lnk-panelfolder{
			.panel-title{
				margin: 16px 0 16px 16px;
				font-size: 14px;
				color: rgba(0,0,0,0.85);
				letter-spacing: 1px;
				line-height: 1;
				span{
					padding: 0 8px;
				}
				.pre-icon{
					background: pl-var(color-primary);
					display: inline-block;
					width: 3px;
					height: 14px;
					vertical-align: bottom;
				}
			}
			.folder-icon{
				cursor: pointer;
				color: #BFBFBF;
			}
			.cancel-margin{
				margin: 16px 0 16px 0;
			}
		}
	}

</style>
